import { __assign, __awaiter, __extends, __generator } from "tslib";
import { ArticleIcon } from './article-icon';
import { ErrorMsg, stripSpaces, Spinner } from '../contact-form-utils';
import { CSSTransitionGroup } from 'react-transition-group';
import { KeyCode } from '@wix/answers-api';
import * as React from 'react';
import * as ReCAPTCHA from 'react-google-recaptcha';
import { debounce, classNames } from '@wix/answers-lib';
import { namespacedClassnames, RenderHtml } from '../../utils';
import TextAreaDefault from 'react-textarea-autosize';
// tslint:disable-next-line:no-duplicate-imports
import * as TextAreaAll from 'react-textarea-autosize';
import { Attachments } from './attachments';
import { Button, Label, MultiInput, Select } from '@wix/answers-ui-libby';
/*
    very hacky, but turns out that there is a different between tests running
    and local environment / widget when it comes to the default exports.
    probably webpack (yoshi or sandbox) do something that our tests / browserify doesn't.
    this wasted enough time for now so the hack below is the best solution but if you see it
    later than April 2019 please try solve it again. 🙏🏻
 */
var TextAreaComp = typeof TextAreaAll === 'object' ? TextAreaDefault : TextAreaAll;
var ReCaptcha = ReCAPTCHA.default;
var TIMEOUT_DELAY = 500;
var MIN_SUBJECT_CHARS = 5;
var MIN_CONTENT_CHARS = 5;
var MAX_CC_RECIPIENTS = 10;
var emailRegex = /^\S+@\S+\.\S+$/;
var SubmitTicket = /** @class */ (function (_super) {
    __extends(SubmitTicket, _super);
    function SubmitTicket() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doSuggestedArticlesDebounce = debounce(function () { return _this.maybeGetSuggestedArticles(); }, TIMEOUT_DELAY);
        _this.state = {
            formIsInvalid: false,
            executingUploadCaptcha: false,
            showLoadingSpinner: false,
            suggestedArticles: [],
            ccEmailShown: false,
            emailConfirmation: '',
            isEmailConfirmationFocused: true
        };
        _this.handleFormSubmit = function (e) {
            e.stopPropagation();
            e.preventDefault();
            _this.onSubmitClick();
        };
        _this.focusEmailConfirmation = function () { return _this.setState({ isEmailConfirmationFocused: true }); };
        _this.blurEmailConfirmation = function () { return _this.setState({ isEmailConfirmationFocused: false }); };
        _this.setLoadingState = function () { return _this.setState({ showLoadingSpinner: true }); };
        _this.hideLoadingState = function () { return _this.setState({ showLoadingSpinner: false }); };
        _this.maybeGetSuggestedArticles = function () { return __awaiter(_this, void 0, void 0, function () {
            var suggestedArticlesResult, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.ticketFormData.title.length > 2)) return [3 /*break*/, 4];
                        suggestedArticlesResult = [];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.props.onGetSuggestedArticles()];
                    case 2:
                        suggestedArticlesResult = _a.sent();
                        this.setState({ suggestedArticles: suggestedArticlesResult });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        // tslint:disable-next-line:no-console
                        console.log('Error getting articles', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.onSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.props.onSubmit()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_2 = _a.sent();
                        // tslint:disable-next-line:no-console
                        console.error('error submitting ticket', e_2);
                        this.hideLoadingState();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.onTicketSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.formIsValid()) return [3 /*break*/, 5];
                        this.setLoadingState();
                        if (!!this.shouldUseCaptcha()) return [3 /*break*/, 1];
                        this.safelyExecuteCaptcha();
                        return [3 /*break*/, 4];
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.onSubmit()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        // tslint:disable-next-line:no-console
                        console.log(e_3);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        if (this.props.onValidationError) {
                            this.props.onValidationError({
                                title: !this.isTitleValid(),
                                description: !this.isDescriptionValid(),
                                email: this.props.isUserAnonymous ? false : !this.isEmailNotEmpty() || !this.isEmailValid(),
                                emailConfirmation: this.props.isUserAnonymous ? false : !this.doEmailsMatch(),
                                name: this.props.isUserAnonymous ? false : !this.isFullnameValid(),
                                customFields: !this.props.areCustomFieldsValid(),
                                partnerCompanyField: this.props.partnerCompanyField && !this.isPartnerCompanyFieldNotEmpty(),
                            });
                        }
                        this.blurEmailConfirmation();
                        this.setState({ formIsInvalid: true });
                        this.hideLoadingState();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.onCaptchaResolve = function (recaptchaValue) { return __awaiter(_this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.props.captchaProps.onCaptchaTokenChange(recaptchaValue);
                        this.captcha.reset();
                        if (!!this.state.executingUploadCaptcha) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.onSubmit()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        // tslint:disable-next-line:no-console
                        console.log(e_4);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.setState({ executingUploadCaptcha: false });
                        if (this.uploadCallback) {
                            this.uploadCallback();
                        }
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.isTitleValid = function () {
            return stripSpaces(_this.props.ticketFormData.title).length >= MIN_SUBJECT_CHARS;
        };
        _this.isDescriptionValid = function () {
            return stripSpaces(_this.props.ticketFormData.description).length >= MIN_CONTENT_CHARS;
        };
        _this.doEmailsMatch = function () { return _this.props.enableEmailConfirmation ?
            (_this.props.ticketFormData.email.toLowerCase() === _this.state.emailConfirmation.toLowerCase()) : true; };
        _this.isPartnerCompanyFieldNotEmpty = function () { return _this.props.ticketFormData.companyId; };
        _this.formIsValid = function () {
            var isUserInfoValid = _this.props.isUserAnonymous ?
                _this.isFullnameValid()
                    && _this.isEmailNotEmpty() && _this.isEmailValid() && _this.doEmailsMatch() : true;
            var isPartnerCompanyFieldValid = _this.props.partnerCompanyField && _this.props.partnerCompanyField.mandatory ?
                _this.isPartnerCompanyFieldNotEmpty() : true;
            return _this.isTitleValid()
                && _this.isDescriptionValid()
                && _this.props.areCustomFieldsValid()
                && isUserInfoValid
                && isPartnerCompanyFieldValid;
        };
        _this.onSubmitClick = function () {
            if (!_this.state.showLoadingSpinner) {
                _this.onTicketSubmit();
            }
        };
        _this.shouldUseCaptcha = function () {
            var _a = _this.props, captchaProps = _a.captchaProps, isUserAnonymous = _a.isUserAnonymous;
            return !captchaProps.data.isRequired && !isUserAnonymous;
        };
        _this.safelyExecuteCaptcha = function () {
            if (!!_this.captcha) {
                _this.captcha.execute();
            }
        };
        _this.maybeExecUploadCaptcha = function (callback) {
            _this.setState({ executingUploadCaptcha: true }, function () {
                _this.uploadCallback = function () { return callback(); };
                _this.safelyExecuteCaptcha();
            });
        };
        _this.onCancel = function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (_this.props.onCancel) {
                _this.props.onCancel();
            }
        };
        _this.onAccessibilitySubmitKeyup = function (e) {
            if (e.keyCode === KeyCode.ENTER || e.keyCode === KeyCode.SPACE) {
                _this.onSubmitClick();
            }
        };
        _this.setSubmitRef = function (elem) {
            if (elem) {
                _this.submitRef = elem;
                elem.addEventListener('keyup', _this.onAccessibilitySubmitKeyup);
            }
        };
        _this.maybeRenderSuggestedArticles = function () {
            var _a = _this.props, onSuggestedArticleClick = _a.onSuggestedArticleClick, logSuggestedArticleClick = _a.logSuggestedArticleClick;
            var suggestedArticles = (_this.state.suggestedArticles || []).map(function (article, idx) {
                var linkAttributes = !onSuggestedArticleClick ?
                    { href: article.url, target: '_blank', onClick: function () { return logSuggestedArticleClick(article); } } :
                    { onClick: function () { return onSuggestedArticleClick(article); } };
                return (React.createElement("li", { className: 'suggested-article', key: idx },
                    React.createElement("a", __assign({}, linkAttributes),
                        React.createElement(ArticleIcon, null),
                        React.createElement("span", { className: 'article-title' }, article.title))));
            });
            var suggestedArticlesComp = (React.createElement("ul", { className: classNames('suggested-articles-container', { top: _this.props.suggestedArticlesUnderSubject }) },
                React.createElement("div", { className: 'section-title' }, _this.props.translate('ticket.suggestions.title')),
                suggestedArticles));
            return (React.createElement(CSSTransitionGroup, { transitionName: 'appear', transitionAppearTimeout: 200, transitionEnterTimeout: 200, transitionLeaveTimeout: 200 }, !_this.state.suggestedArticles.length ? null : suggestedArticlesComp));
        };
        _this.renderFormActions = function () {
            var translate = _this.props.translate;
            var loading = _this.state.showLoadingSpinner ? 'loading' : '';
            var hasCancelBtn = !!_this.props.onCancel;
            var maybeRenderCancelBtn = hasCancelBtn ? (React.createElement("button", { className: 'cancel', onClick: _this.onCancel }, translate('ticket.cancel'))) : null;
            var renderSubmitBtn = (React.createElement("div", { tabIndex: 0, ref: _this.setSubmitRef },
                React.createElement("button", { tabIndex: -1, className: 'submit' },
                    React.createElement("span", { className: 'submit-text' }, translate('ticket.submit')),
                    React.createElement(Spinner, null))));
            var recaptchaMessage = React.createElement(RenderHtml, { className: 'recaptcha-message', html: translate('ticket.recaptcha-message-html') });
            var maybeFormActionsWithRecaptchaMessage = (React.createElement("div", { className: 'form-actions-recaptcha-msg' },
                React.createElement("div", { className: "form-actions " + loading },
                    renderSubmitBtn,
                    maybeRenderCancelBtn),
                recaptchaMessage));
            return _this.props.hideRecaptchaBadge ? maybeFormActionsWithRecaptchaMessage :
                (React.createElement("div", { className: "form-actions " + loading },
                    renderSubmitBtn,
                    maybeRenderCancelBtn));
        };
        _this.captchaRef = function (ref) { return _this.captcha = ref; };
        _this.onChangeFullname = function (e) { return _this.props.onChange(__assign(__assign({}, _this.props.ticketFormData), { fullname: e.target.value })); };
        _this.onChangeEmail = function (e) { return _this.props.onChange(__assign(__assign({}, _this.props.ticketFormData), { email: e.target.value })); };
        _this.onChangeEmailConfirmation = function (e) {
            _this.setState({ emailConfirmation: e.target.value });
            _this.focusEmailConfirmation();
        };
        _this.onChangeCCEmail = function (ccRecipients) { return _this.props.onChange(__assign(__assign({}, _this.props.ticketFormData), { ccRecipients: ccRecipients })); };
        _this.onChangeTitle = function (e) { return _this.props.onChange(__assign(__assign({}, _this.props.ticketFormData), { title: e.target.value })); };
        _this.onChangeDescription = function (e) { return _this.props.onChange(__assign(__assign({}, _this.props.ticketFormData), { description: e.target.value })); };
        _this.onChangeCompany = function (option) { return _this.props.onChange(__assign(__assign({}, _this.props.ticketFormData), { companyId: option.value })); };
        _this.onChangeAttachments = function (newAttachments) {
            _this.props.onChange(__assign(__assign({}, _this.props.ticketFormData), { attachments: newAttachments }));
        };
        _this.onToggleCcEmail = function (e) {
            e.stopPropagation();
            e.preventDefault();
            _this.setState({ ccEmailShown: !_this.state.ccEmailShown }, function () { var _a; return !_this.state.ccEmailShown && ((_a = _this.props.ticketFormData.ccRecipients) === null || _a === void 0 ? void 0 : _a.length) && _this.onChangeCCEmail([]); });
        };
        _this.maybeRenderUserInfoSection = function () {
            var _a = _this, props = _a.props, state = _a.state;
            var translate = props.translate;
            var showFullnameError = !_this.isFullnameValid() && state.formIsInvalid;
            var fullnameErrorMsg = React.createElement(ErrorMsg, { msg: translate('user-info.fullname.error'), isVisible: showFullnameError });
            var emailIsEmpty = !_this.isEmailNotEmpty() && state.formIsInvalid;
            var emailIsInvalid = !_this.isEmailValid() && _this.isEmailNotEmpty() && state.formIsInvalid;
            var emailsDoNotMatch = !_this.state.isEmailConfirmationFocused && !_this.doEmailsMatch();
            var emailErrorText = emailIsEmpty ? 'user-info.email.error' : 'user-info.email.error.invalid';
            var emailConfirmationSection = (React.createElement("label", { className: 'input-field email-confirmation' },
                translate('user-info.email-confirmation'),
                React.createElement("input", { onBlur: _this.blurEmailConfirmation, "aria-invalid": emailsDoNotMatch, type: 'email', value: state.emailConfirmation, onChange: _this.onChangeEmailConfirmation, placeholder: translate('user-info.email-confirmation.placeholder') }),
                React.createElement(ErrorMsg, { msg: translate('user-info.email-confirmation.error'), isVisible: emailsDoNotMatch })));
            var userInfoComp = (React.createElement("div", { className: 'user-info-section' },
                React.createElement("label", { className: 'input-field user-fullname' },
                    translate('user-info.fullname'),
                    React.createElement("input", { "aria-invalid": showFullnameError, type: 'text', value: props.ticketFormData.fullname, onChange: _this.onChangeFullname, placeholder: translate('user-info.fullname.placeholder') }),
                    fullnameErrorMsg),
                React.createElement("label", { className: 'input-field user-email' },
                    translate('user-info.email'),
                    React.createElement("input", { "aria-invalid": emailIsEmpty || emailIsInvalid, type: 'email', value: props.ticketFormData.email, onChange: _this.onChangeEmail, placeholder: translate('user-info.email.placeholder') }),
                    React.createElement(ErrorMsg, { msg: translate(emailErrorText), isVisible: emailIsEmpty || emailIsInvalid })),
                _this.props.enableEmailConfirmation ? emailConfirmationSection : null));
            return _this.props.isUserAnonymous ? userInfoComp : null;
        };
        _this.maybeRenderCcEmail = function () {
            var _a;
            var t = _this.props.translate;
            var buttonText = _this.state.ccEmailShown ?
                t('user-info.remove-cc-email.button') : t('user-info.add-cc-email.button');
            var values = _this.props.ticketFormData.ccRecipients || [];
            var renderCcItem = function (props) {
                var tag = props.tag, idx = props.idx, onRemove = props.onRemove;
                var onClick = function (_) { return onRemove(idx); };
                return (React.createElement(Label, { onRemove: onClick, className: 'cc-item', key: idx }, tag));
            };
            var maxValuesReached = ((_a = _this.props.ticketFormData.ccRecipients) === null || _a === void 0 ? void 0 : _a.length) === MAX_CC_RECIPIENTS;
            var renderCcEmailInput = _this.state.ccEmailShown && (React.createElement("label", { className: classNames('user-email-cc', { 'max-reached': maxValuesReached }) },
                t('user-info.cc-email', { max: MAX_CC_RECIPIENTS }),
                React.createElement(MultiInput, { className: 'cc-input', values: values, placeholder: t('user-info.cc-email.placeholder'), maxTags: MAX_CC_RECIPIENTS, onChange: _this.onChangeCCEmail, validationRegex: emailRegex, renderTag: renderCcItem, additionalAddKeys: [KeyCode.COMMA], disableTypingOnMaxTags: 'hidden tooltip' }),
                maxValuesReached && React.createElement("div", { className: 'max-reached' }, t('user-info.cc-email.max-recipients-error'))));
            return (React.createElement("div", { className: 'add-cc-section' },
                renderCcEmailInput,
                React.createElement(Button, { type: 'secondary', onClick: _this.onToggleCcEmail, className: 'add-cc-button' }, buttonText)));
        };
        return _this;
    }
    SubmitTicket.prototype.componentWillUnmount = function () {
        if (this.submitRef) {
            this.submitRef.removeEventListener('keyup', this.onAccessibilitySubmitKeyup);
        }
    };
    SubmitTicket.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.ticketFormData.title !== nextProps.ticketFormData.title) {
            this.doSuggestedArticlesDebounce();
        }
    };
    SubmitTicket.prototype.isFullnameValid = function () {
        return stripSpaces(this.props.ticketFormData.fullname).length > 0;
    };
    SubmitTicket.prototype.isEmailNotEmpty = function () {
        return stripSpaces(this.props.ticketFormData.email).length > 0;
    };
    SubmitTicket.prototype.isEmailValid = function () {
        return emailRegex.test(this.props.ticketFormData.email);
    };
    SubmitTicket.prototype.render = function () {
        var _a, _b;
        var props = this.props;
        var formIsInvalid = this.state.formIsInvalid;
        var onAttachmentUpload = props.onAttachmentUpload, captchaProps = props.captchaProps, isUserAnonymous = props.isUserAnonymous, translate = props.translate;
        var cn = namespacedClassnames('submit-ticket-form', { 'recaptcha-msg': this.props.hideRecaptchaBadge });
        var showTitleError = !this.isTitleValid() && formIsInvalid;
        var titleErrorMsg = React.createElement(ErrorMsg, { msg: translate('ticket.title.error'), isVisible: showTitleError });
        var showDescriptionError = !this.isDescriptionValid() && formIsInvalid;
        var descriptionErrorMsg = React.createElement(ErrorMsg, { msg: translate('ticket.description.error'), isVisible: showDescriptionError });
        var reCaptchaComp = this.shouldUseCaptcha() ? null : (React.createElement(ReCaptcha, { className: 'recaptcha-container', ref: this.captchaRef, size: 'invisible', onChange: this.onCaptchaResolve, sitekey: captchaProps.data.key, badge: captchaProps.data.position || 'bottomright' }));
        var attachmentsComp = (React.createElement(Attachments, { t: translate, attachments: props.ticketFormData.attachments, onChange: this.onChangeAttachments, onUpload: onAttachmentUpload, captchaToken: captchaProps.captchaToken, execCaptcha: !!isUserAnonymous ? this.maybeExecUploadCaptcha : undefined, allowedFileTypes: props.allowedFileTypes }));
        var ticketTitleComp = (React.createElement("label", { className: 'input-field ticket-title' },
            translate('ticket.title'),
            React.createElement("input", { type: 'text', "aria-invalid": showTitleError, value: props.ticketFormData.title, onChange: this.onChangeTitle, placeholder: translate('ticket.title.placeholder') }),
            titleErrorMsg));
        var ticketDescriptionComp = (React.createElement("label", { className: 'input-field ticket-description' },
            translate('ticket.description'),
            React.createElement(TextAreaComp, { "aria-invalid": showDescriptionError, minRows: 3, maxRows: 6, value: props.ticketFormData.description, onChange: this.onChangeDescription, placeholder: translate('ticket.description.placeholder') }),
            descriptionErrorMsg));
        var localCompanyCompare = function (a, b) {
            return a.name.localeCompare(b.name);
        };
        var showPartnerCompanyFieldError = !!((_a = props.partnerCompanyField) === null || _a === void 0 ? void 0 : _a.mandatory) && !this.isPartnerCompanyFieldNotEmpty() && formIsInvalid;
        var partnerCompanyFieldErrorMsg = (React.createElement(ErrorMsg, { msg: translate('custom-field.error.mandatory'), isVisible: showPartnerCompanyFieldError }));
        var companySelectComp = (((_b = props.partnerCompanyField) === null || _b === void 0 ? void 0 : _b.companies) && (React.createElement("label", { className: 'single-select-field ticket-company' },
            translate('ticket.company.select'),
            React.createElement(Select, { value: props.ticketFormData.companyId, onChange: this.onChangeCompany, options: props.partnerCompanyField.companies.sort(localCompanyCompare).map(function (company) { return ({ value: company.id, label: company.name }); }), placeholder: translate('ticket.company.empty') }),
            partnerCompanyFieldErrorMsg)));
        return (React.createElement("form", { className: cn, onSubmit: this.handleFormSubmit, noValidate: true },
            this.maybeRenderUserInfoSection(),
            ticketTitleComp,
            props.suggestedArticlesUnderSubject && this.maybeRenderSuggestedArticles(),
            ticketDescriptionComp,
            attachmentsComp,
            props.renderCustomFields(formIsInvalid),
            props.addCCEmail && this.maybeRenderCcEmail(),
            companySelectComp,
            reCaptchaComp,
            !props.suggestedArticlesUnderSubject && this.maybeRenderSuggestedArticles(),
            this.renderFormActions()));
    };
    return SubmitTicket;
}(React.Component));
export { SubmitTicket };
//# sourceMappingURL=submit-ticket.comp.js.map